import { cartStore } from 'src/sdk/cart'
import { sessionStore } from 'src/sdk/session'

declare global {
  interface Window {
    addToCart?: (itemId: string, quantity?: number) => void
  }
}
//50939
if (typeof window !== 'undefined' && !window.addToCart) {
  window.addToCart = async (itemId, quantity = 1) => {
    const session = sessionStore.read()

    const locator = [
      { key: 'id', value: `${itemId}` },
      { key: 'channel', value: session.channel },
      { key: 'locale', value: session.locale },
    ]

  const queryParams = new URLSearchParams({
      operationName: 'BrowserProductQuery',
      variables: JSON.stringify({ locator }),
    })


    try {
   const response = await fetch(`/api/graphql?${queryParams.toString()}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const result = await response.json()

      const product = result?.data?.product

      if (!product) {
        console.error('No se encontró el producto con ID:', itemId)
        return
      }

      const offer = product.offers?.offers?.[0]

      const item = {
        id: product.id,
        price: offer?.price ?? 0,
        listPrice: offer?.listPrice ?? 0,
        seller: offer?.seller,
        unitMultiplier: product.unitMultiplier ?? 1,
        measurementUnit: product.measurementUnit ?? 'un',
        itemOffered: {
          additionalProperty: product.additionalProperty,
          brand: product.brand,
          isVariantOf: product.isVariantOf,
          name: product.name,
          sku: product.sku,
          gtin: product.gtin,
          image: product.image,
        },
        quantity,
      }

      cartStore.addItem(item)
    } catch (error) {
      console.error('Error al agregar al carrito:', error)
    }
  }
}
